<template>
  <div class="w-100">
    <div class="alert alert-info" role="alert" v-show="alertMessage">
      {{ alertMessage }}
    </div>
    <TemplateModal
      :show="modalAction.show"
      @handleClose="modalAction.show = false"
      :center="true"
    >
      <div class="modal-content">
        <div class="modal-header">
          <p class="fw-bold modal-title fsize-14">{{ modalAction.title }}</p>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <label class="col-lg-12 col-form-label fw-bold text-start">
              {{ modalAction.text }}
            </label>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary bg-white text-body fw-bold me-3 border border-0 text-uppercase"
            @click="modalAction.show = false"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-secondary bg-white fw-bold text-danger border border-0 text-uppercase"
            @click="handleConfirm"
          >
            Confirm
          </button>
        </div>
      </div>
    </TemplateModal>
    <TemplateModal
      :show="modalAlert.show"
      @handleClose="modalAlert.show = false"
      :center="true"
    >
      <div class="modal-content">
        <div class="modal-header">
          <p class="fw-bold modal-title fsize-14">{{ modalAlert.title }}</p>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <label class="col-lg-12 col-form-label fw-bold text-start">
              {{ modalAlert.text }}
            </label>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary bg-white fw-bold text-danger border border-0 text-uppercase"
            @click="modalAlert.show = false"
          >
            Understand
          </button>
        </div>
      </div>
    </TemplateModal>
    <TableBasic :payload="payload" @onChange="changeParameter">
      <template v-if="!isToggle" v-slot:empty_table>
        <div class="empty-table">
          <span> UA Promo list disabled </span>
        </div>
      </template>
      <template v-if="!loadingSetting" v-slot:table_head>
        <div class="d-flex gap-4">
          <div class="d-flex align-items-center bg-white px-4 py-2 border">
            <span class="fw-bold me-5"> Enable Promo List </span>
            <Toggle :value="isToggle" @onChange="handleToggle" />
          </div>
          <div class="d-flex align-items-center">
            <span class="me-3">Number of Product Listed</span>
            <CustomInput
              type="number"
              placeholder="1"
              :value="numListed"
              @onChange="(value) => (numListed = value)"
              :inputStyle="{
                maxWidth: '56px',
              }"
              :max="1000"
              :min="1"
              :disabled="!isToggle"
              @onFocus="tempInputNum = numListed"
              @onEnter="handleEnterNumListed"
              @onBlur="numListed = tempInputNum"
            />
          </div>
          <div class="d-flex align-items-center">
            <span class="me-3">Total Product Count Allowed</span>
            <CustomInput
              type="number"
              placeholder="1"
              :value="countMax"
              @onChange="(value) => (countMax = value)"
              :inputStyle="{
                maxWidth: '56px',
              }"
              :max="1000"
              :min="1"
              :disabled="!isToggle"
              @onFocus="tempInputCount = countMax"
              @onEnter="handleEnterCountMaxListed"
              @onBlur="countMax = tempInputCount"
            />
          </div>
        </div>
      </template>
      <template v-slot:date="{ data }">
        <div>
          {{ data.created_date }} <br />
          by {{ data.created_by_name }}
        </div>
      </template>
      <template v-slot:name="{ value, data }">
        <div>
          <router-link
            :to="'/products/category-promo/detail/' + data.id"
            class="text-decoration-none"
            style="color: #5e50a1"
          >
            {{ value }}
          </router-link>
        </div>
      </template>
      <template v-slot:product_count="{ data, value }">
        <div>
          <router-link
            :to="'/products/category-promo/detail/' + data.id"
            class="fw-bold text-danger text-decoration-none"
          >
            {{ value }} Products
          </router-link>
        </div>
      </template>
      <template v-slot:date_start="{ value }">
        <div>
          <span>{{ value != "" ? value : "" }}</span>
        </div>
      </template>
      <template v-slot:date_end="{ value }">
        <div>
          <span>{{ value != "" ? value : "" }}</span>
        </div>
      </template>
      <template v-slot:actions="{ data }">
        <div class="d-flex justify-content-center">
          <!-- Display Active Checkbox -->
          <input
            v-if="data.is_active"
            class="form-check-input mt-0"
            type="checkbox"
            checked
            @click="handleCheck($event, data)"
          />
          <!-- Display non-Active Checkbox -->
          <input
            v-else
            class="form-check-input mt-0"
            type="checkbox"
            @click="handleCheck($event, data)"
          />
        </div>
      </template>
    </TableBasic>
  </div>
</template>

<script>
import moment from "moment";
import TableBasic from "@/components/TableBasic.vue";
import TemplateModal from "@/components/TemplateModal.vue";
import Toggle from "@/components/Toggle.vue";
import CustomInput from "@/components/CustomInput.vue";

export default {
  components: {
    TableBasic,
    TemplateModal,
    Toggle,
    CustomInput,
  },
  data() {
    return {
      loadingSetting: true,
      isToggle: false,
      modalAction: {
        type: "",
        show: false,
        title: "",
        text: "",
      },
      modalAlert: {
        show: false,
        title: "",
        text: "",
      },
      tempInputNum: 0,
      numListed: 50,
      numListedLimit: 50,
      tempInputCount: 0,
      countMax: 100,
      countMaxLimit: 500,
      selectedCategory: {},
      payload: {
        header: [
          {
            key: "date",
            label: "CREATED DATE",
            class: "",
            sort: true,
            sort_key: "created_date",
          },
          {
            key: "name",
            label: "CATEGORY NAME",
            class: "",
            sort: true,
            sort_key: "name",
          },
          {
            key: "badge_title",
            label: "BADGE TITLE",
            class: "",
            sort: true,
            sort_key: "badge_title",
          },
          {
            key: "product_count",
            label: "COUNT",
            class: "",
            sort: true,
            sort_key: "product_count",
          },
          {
            key: "date_start",
            label: "START DATE",
            class: "",
            sort: true,
            sort_key: "date_start",
          },
          {
            key: "date_end",
            label: "END DATE",
            class: "",
            sort: true,
            sort_key: "date_end",
          },
          {
            key: "actions",
            label: "SHOW IN UA PROMO LIST",
            class: "text-center",
          },
        ],
        value: [],
        search: true,
        searchDisabled: false,
        searchInput: "",
        searchPlaceholder: "Search by category, badge title",
        searchContainerStyle: {
          maxWidth: "250px",
        },
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        // default sorting
        sortBy: "is_promo_page",
        sortType: "-1",
      },
      alertMessage: "",
    };
  },
  watch: {
    promoListSetting(val) {
      this.countMax = val.total_product_allowed;
    },
  },
  computed: {
    promoListSetting() {
      return this.$store.state.marketing.promoListSetting;
    },
    settingCategoryDetail() {
      const storeData = this.$store.state.marketing.promoListData;
      if (this.promoListSetting.category_promo_id) {
        return storeData.find(
          (x) => x.id == this.promoListSetting.category_promo_id
        );
      }

      return {};
    },
  },
  async mounted() {
    this.setSortSearchTable(false)
    await this.getSettings();
    if (this.promoListSetting.is_active) {
      this.getData();
    }
  },
  methods: {
    setSortSearchTable(bool) {
      let sortStyle = 'pointer-events: none; cursor: default'
      this.payload.header = [...this.payload.header].map(x=> ({...x, sort_style: !bool ? sortStyle : 'none'}))
      this.payload.searchDisabled = !bool
    },
    handleToggle(bool) {
      const payload = {
        category_promo_id: this.promoListSetting.category_promo_id,
        is_active: bool,
      };
      this.$store.dispatch("marketing/updatePromoListSetting", payload);
      this.isToggle = bool;

      if (!this.payload.value.length && bool) {
        this.getData();
        return;
      }

      // reset table value
      if (!bool) {
        this.payload.value = [];
        this.payload.sortBy = "is_promo_page";
        this.payload.sortType = "-1";
        this.payload.searchInput = "";
        this.setSortSearchTable(false)
      }
    },
    handleCheck(e, data) {
      const { checked } = e.target;
      e.preventDefault();
      // console.log({checked, data})
      this.selectedCategory = data;
      if (checked) {
        this.modalAction = {
          type: "add",
          show: true,
          title: "Add Category To Promo List",
          text: "Are you sure to add this category to be shown in Userapp promo list?",
        };
      } else {
        let title = "Remove Category from Promo List";
        let text =
          "By confirming, this category will be removed from displayed UA Promo List products";

        if (data.is_expired) {
          title = "Category Expired";
          text =
            "Are you sure to delete this category? By confirming, this category will be removed from the list because it has expired.";
        }

        this.modalAction = {
          type: "remove",
          show: true,
          title,
          text,
        };
      }
    },
    handleConfirm() {
      if (this.modalAction.type === "add") {
        this.handleAddCatPromoUA();
      }
      if (this.modalAction.type === "remove") {
        this.handleRemoveCatPromoUA();
      }
    },
    handleAddCatPromoUA() {
      this.handleChecked(true);
      this.modalAction.show = false;
    },
    handleRemoveCatPromoUA() {
      this.handleChecked(false);
      this.modalAction.show = false;
    },
    async handleChecked(bool = false) {
      const prevCatId = this.promoListSetting.category_promo_id;
      const currentCatId = this.selectedCategory.id;
      const payload = {
        is_active: this.promoListSetting.is_active,
        category_promo_id: currentCatId !== prevCatId ? currentCatId : "",
        remove_category_promo_id:
          currentCatId !== prevCatId ? prevCatId : currentCatId,
      };

      // console.log({ payload });

      if (
        this.selectedCategory?.product_count >
        this.promoListSetting.total_product_allowed
      ) {
        this.modalAlert = {
          show: true,
          title: "Show in UA Promo List",
          text: `The Number of products chosen exceed the limit allowed (${this.promoListSetting.total_product_allowed}).`,
        };

        return;
      }

      try {
        // HIT API BELOW
        await this.$store.dispatch("marketing/updatePromoListSetting", payload);
        const selectedIndex = this?.payload?.value?.findIndex(
          (x) => x.id === this.selectedCategory.id
        );
        if (this.payload.value[selectedIndex]) {
          // reset all payload checked value
          this.payload.value = [...this.payload.value].map((x) => {
            return {
              ...x,
              is_active: false,
            };
          });
          //
          this.payload.value[selectedIndex] = {
            ...this.payload.value[selectedIndex],
            is_active: bool,
          };
        }
      } catch (err) {
        const errMsg =
          err?.response?.data?.errorMessage || "Something went wrong";
        this.modalAlert = {
          show: true,
          title: "Show in UA Promo List",
          text: errMsg,
        };
      }
    },
    async handleEnterNumListed(e) {
      let error = "";
      let title = "";

      if (this.numListed > this.numListedLimit) {
        title = "Max Number of Product Listed";
        error = `The Number of product listed exceed the maximum value allowed (${this.numListedLimit})`;
      }

      if (error) {
        this.modalAlert = {
          show: true,
          title,
          text: error,
        };
        this.numListed = this.tempInputNum;
        e.target.blur();
        return;
      }
      const payload = {
        is_active: this.promoListSetting.is_active,
        category_promo_id: this.promoListSetting.category_promo_id,
        number_of_product: this.numListed || 0,
      };
      try {
        await this.$store.dispatch("marketing/updatePromoListSetting", payload);
        this.tempInputNum = this.numListed;
      } catch (err) {
        const errMsg =
          err?.response?.data?.errorMessage || "Something went wrong";
        this.modalAlert = {
          show: true,
          title: "Number of product listed",
          text: errMsg,
        };
        this.numListed = this.tempInputNum;
      }
      e.target.blur();
    },
    async handleEnterCountMaxListed(e) {
      let error = "";
      let title = "";
      if (this.countMax > this.countMaxLimit) {
        title = "Max Number of Product Count Allowed";
        error =
          "The Number of product count allowed reach the maximum value allowed (500)";
      }

      if (
        this.settingCategoryDetail?.product_count &&
        this.countMax < this.settingCategoryDetail?.product_count
      ) {
        title = "Number of Product Count Allowed";
        error = `Please insert the number that is greater than current chosen product count combined (${this.settingCategoryDetail?.product_count}).`;
      }

      if (error) {
        this.modalAlert = {
          show: true,
          title,
          text: error,
        };
        this.countMax = this.tempInputCount;
        e.target.blur();
        return;
      }
      const payload = {
        is_active: this.promoListSetting.is_active,
        category_promo_id: this.promoListSetting.category_promo_id,
        total_product_allowed: this.countMax || 0,
      };
      try {
        await this.$store.dispatch("marketing/updatePromoListSetting", payload);
        this.tempInputCount = this.countMax;
      } catch (err) {
        const errMsg =
          err?.response?.data?.errorMessage || "Something went wrong";
        this.modalAlert = {
          show: true,
          title: "Number of Product Count",
          text: errMsg,
        };
        this.countMax = this.tempInputCount;
      }
      e.target.blur();
    },
    changeParameter(value) {
      console.log(value);
      this.payload.perPage = value.per_page;
      this.payload.currentPage = value.current_page;
      this.payload.searchInput = value.search;
      this.payload.sortType = value.sort_type;
      this.payload.sortBy = value.sort_by;
      this.getData();
    },
    async getData() {
      let payload = {
        page: this.payload.currentPage,
        size: this.payload.perPage,
        is_only_active: true,
        timezone: "Asia/Jakarta",
      };
      if (this.payload.searchInput != "") {
        payload.keyword = this.payload.searchInput;
      }

      if (this.payload.sortBy != "") {
        payload.sort_by = this.payload.sortBy;
        payload.sort_type = this.payload.sortType;
      }

      const response = await this.$store.dispatch(
        "marketing/getPromoList",
        payload
      );

      const items = response.items || []

      const resdata = items.map((x) => {
        let diff = moment(x.date_end).diff(moment(), "days")
        let isExpired = diff < 0 && x.date_end != "0001-01-01T00:00:00Z"
        return {
          ...x,
          created_date: moment(x.created_date).format("DD MMM YYYY"),
          date_start:
            x.date_start != "0001-01-01T00:00:00Z"
              ? moment(x.date_start).format("DD MMM YYYY")
              : "",
          date_end:
            x.date_end != "0001-01-01T00:00:00Z"
              ? moment(x.date_end).format("DD MMM YYYY")
              : "",
          is_expired: isExpired,
        };
      });

      // NOTE map to add is_check value
      const modified = [...resdata].map((x) => {
        const isActive = x.id === this.promoListSetting.category_promo_id;
        return {
          ...x,
          is_active: isActive,
          is_disabled: x.is_expired,
        };
      });

      this.setSortSearchTable(true)
      this.payload.value = modified;
      this.payload.totalRows = response.count;
    },
    async getSettings() {
      this.loadingSetting = true
      await this.$store.dispatch("marketing/getPromoListSetting");
      this.isToggle = this.promoListSetting.is_active;
      this.numListed = this.promoListSetting.number_of_product;
      this.countMax = this.promoListSetting.total_product_allowed;
      this.loadingSetting = false
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-table {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f2f8;
  color: #424143;
  height: 3rem;
}
</style>
